export default __webpack_public_path__ + "static/media/heavytrucks_banner.553cafe5.jpg";